import React from 'react';
import { StyledHeader } from './Header.styles';
import Button from '../Button';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const navigate = useNavigate();
  return (
    <>
      <StyledHeader>
        <Button width="120px" onClick={() => navigate('/upgrade-plan')}>
          Upgrade
        </Button>
      </StyledHeader>
    </>
  );
};

export default Header;
